import React from 'react'
import { PricingSlider } from '@vp/lat-react-component-library'
import { useAppState } from '../../../root/contexts/AppContext'
import { useTenant } from '../../../root/contexts/TenantContext'

type PriceSliderProps = {
  minimumOrderQuantity: number
  maximumOrderQuantity: number | undefined
  quantityIncrement?: number
  productKey: string
  productVersion: number
  lowestPriceAttributes: Record<string, string>
  initialInputQuantity: number
  stock: number
  onHardgoodQuantityChange: (newQuantity: number | undefined) => void
  singleValueSize: string | undefined
}

const PricingSliderWrapper: React.FC<PriceSliderProps> = React.memo(
  ({
    minimumOrderQuantity,
    maximumOrderQuantity,
    quantityIncrement,
    productKey,
    productVersion,
    lowestPriceAttributes,
    initialInputQuantity,
    stock,
    onHardgoodQuantityChange,
    singleValueSize,
  }) => {
    const { culture } = useAppState()
    const { merchantId } = useTenant()

    return (
      <PricingSlider
        minimumOrderQuantity={minimumOrderQuantity}
        maximumOrderQuantity={maximumOrderQuantity}
        quantityIncrement={quantityIncrement}
        productInfo={{
          productKey: productKey,
          productVersion: productVersion,
          merchant: merchantId,
          selections: lowestPriceAttributes,
        }}
        culture={culture}
        quantity={initialInputQuantity}
        stock={stock}
        onValueChanged={onHardgoodQuantityChange}
        quantityTextInputLabel={singleValueSize}
        paddingX={5}
        paddingY={4}
      />
    )
  },
)

export default PricingSliderWrapper
